function getLayoutElement() {
    return document.querySelector('.layout-element');
}

function getLayoutHeader() {
    return document.querySelector('.layout-header');
}

function getLayoutScrollElement() {
    return document.querySelector('.layout-scrollable') || null;
}

function getLayoutPortalElement() {
    return document.body;
}

export {
    getLayoutElement,
    getLayoutHeader,
    getLayoutScrollElement,
    getLayoutPortalElement
}
